export default __webpack_public_path__ + "static/media/deal-hend.5379e9be.svg";